/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz-trans/client';

import Metrics from '@spotahome/soyuz-tracking';

import { useFooterLinks } from '../../../context/ExternalLink';
import Button from '../../Button';

import IconConfetti from '../icons/IconConfetti';
import IconWhatsapp from '../icons/IconWhatsapp';

import styles from '../SpottyCat.module.scss';

const WHATSAPP_URL = 'https://wa.me/+34911983151';

const Success = ({ email, searchUrl, isWhatsappShown, isContactUsShown }) => {
  const externalLinks = useFooterLinks();

  useEffect(() => {
    Metrics.ga.sendEvent('SpottyCat', 'FormSuccess', 'Arrival');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCTASubmit = () => {
    Metrics.ga.sendEvent('SpottyCat', 'FormSuccess', 'Click-CTA');
  };

  const handleWhatsappClick = () => {
    Metrics.ga.sendEvent('SpottyCat', 'FormSuccess', 'Click-WhatsApp');
  };

  const handleContactUsClick = () => {
    Metrics.ga.sendEvent('SpottyCat', 'FormSuccess', 'Click-ContactUs');
  };

  return (
    <div className={styles['spotty-cat__success']}>
      <div className={styles['spotty-cat__success-icon']}>
        <IconConfetti />
      </div>

      <span className={styles['spotty-cat__success-title']}>
        {trans('spotty-cat-screen-title-feedback')}
      </span>

      <div>
        <p>{trans('spotty-cat-screen-title-feedback-description')}</p>
        <p className={styles['spotty-cat__success-highlighted']}>{email}</p>
        <Button
          size="medium"
          className={styles['spotty-cat__button']}
          onClick={handleCTASubmit}
          href={searchUrl}
        >
          {trans('spotty-cat-screen-feedback-cta')}
        </Button>
      </div>

      {isWhatsappShown && (
        <div className={styles['spotty-cat__success-whatsapp']}>
          <p className={styles['spotty-cat__success-highlighted']}>
            {trans('spotty-cat.whatsapp.title')}
          </p>
          <p>{trans('spotty-cat.whatsapp.subtitle')}</p>
          <Button
            className={styles['spotty-cat__button--whatsapp']}
            href={WHATSAPP_URL}
            target="_blank"
            color="tertiary"
            size="medium"
            renderIcon={() => <IconWhatsapp />}
            onClick={handleWhatsappClick}
          >
            {trans('spotty-cat.whatsapp.cta')}
          </Button>
        </div>
      )}

      {isContactUsShown && (
        <div className={styles['spotty-cat__success-whatsapp']}>
          <p className={styles['spotty-cat__success-highlighted']}>
            {trans('spotty-cat.contact-us.title')}
          </p>
          <p>{trans('spotty-cat.contact-us.subtitle')}</p>
          <Button
            className={styles['spotty-cat__button--whatsapp']}
            href={externalLinks.contactUs}
            target="_blank"
            color="tertiary"
            size="small"
            onClick={handleContactUsClick}
          >
            {trans('spotty-cat.contact-us.cta')}
          </Button>
        </div>
      )}
    </div>
  );
};

Success.propTypes = {
  email: PropTypes.string.isRequired,
  searchUrl: PropTypes.string.isRequired,
  isWhatsappShown: PropTypes.bool.isRequired,
  isContactUsShown: PropTypes.bool.isRequired
};

export default Success;
